import React from "react";
import Input from "components/ui/Input";
import Icon from "components/AppIcon";

const ACCOUNTS = [
  { value: "acc-001", label: "SM Supermarket - Makati" },
  { value: "acc-002", label: "Robinsons Supermarket - Quezon City" },
  { value: "acc-003", label: "Puregold - Pasig" },
  { value: "acc-004", label: "Metro Gaisano - Cebu City" },
  { value: "acc-005", label: "Landers Superstore - Alabang" },
  { value: "acc-006", label: "Walter Mart - Cavite" },
  { value: "acc-007", label: "Savemore Market - Davao" },
  { value: "acc-008", label: "Prince Hypermart - Iloilo" },
];

export default function OrderForm({ formData, onChange, onRepeatLastOrder }) {
  return (
    <div className="card p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading font-semibold text-base text-foreground flex items-center gap-2">
          <Icon name="ClipboardList" size={18} color="var(--color-primary)" strokeWidth={2} />
          Order Details
        </h3>
        <button
          onClick={onRepeatLastOrder}
          className="flex items-center gap-1.5 px-3 py-1.5 bg-secondary text-secondary-foreground rounded-md font-caption text-xs font-medium hover:opacity-90 transition-opacity press-effect"
        >
          <Icon name="RefreshCw" size={13} color="currentColor" strokeWidth={2} />
          Repeat Last Order
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="font-caption text-sm font-medium text-foreground block mb-1.5">
            Account / Customer <span className="text-destructive">*</span>
          </label>
          <select
            value={formData?.accountId}
            onChange={(e) => onChange("accountId", e?.target?.value)}
            className="w-full px-3 py-2 border border-input rounded-md bg-card text-foreground font-caption text-sm focus:outline-none focus:ring-2 focus:ring-ring"
          >
            <option value="">Select account...</option>
            {ACCOUNTS?.map((a) => (
              <option key={a?.value} value={a?.value}>{a?.label}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="font-caption text-sm font-medium text-foreground block mb-1.5">
            Delivery Date <span className="text-destructive">*</span>
          </label>
          <input
            type="date"
            value={formData?.deliveryDate}
            onChange={(e) => onChange("deliveryDate", e?.target?.value)}
            min={new Date()?.toISOString()?.split("T")?.[0]}
            className="w-full px-3 py-2 border border-input rounded-md bg-card text-foreground font-caption text-sm focus:outline-none focus:ring-2 focus:ring-ring"
          />
        </div>

        <div className="md:col-span-2">
          <Input
            label="Delivery Address"
            type="text"
            placeholder="e.g. 123 Rizal St., Barangay San Antonio, Makati City, Metro Manila 1200"
            value={formData?.deliveryAddress}
            onChange={(e) => onChange("deliveryAddress", e?.target?.value)}
          />
        </div>

        <div className="md:col-span-2">
          <label className="font-caption text-sm font-medium text-foreground block mb-1.5">Special Instructions</label>
          <textarea
            value={formData?.specialInstructions}
            onChange={(e) => onChange("specialInstructions", e?.target?.value)}
            placeholder="e.g. Deliver before 10AM, contact warehouse manager upon arrival..."
            rows={3}
            className="w-full px-3 py-2 border border-input rounded-md bg-card text-foreground font-caption text-sm focus:outline-none focus:ring-2 focus:ring-ring resize-none"
          />
        </div>
      </div>
    </div>
  );
}